import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:w-10/12 w-11/12 sx:min-h-screen overflow-x-hidden flex flex-col justify-center mx-auto items-center text-parentText" }
const _hoisted_2 = { class: "w-full flex justify-center items-center mt-20" }
const _hoisted_3 = { class: "flex" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Nav = _resolveComponent("Nav")
  const _component_SubNav = _resolveComponent("SubNav")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Nav),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_scrollbar, { class: "flex" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeInLeft",
              "leave-active-class": "animate__animated animate__fadeOutLeft"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SubNav, {
                  class: "pb-3",
                  routes: $data.routes,
                  titles: $data.titles,
                  onSelectedGenre: $options.fetchBooksByGenre
                }, null, 8, ["routes", "titles", "onSelectedGenre"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_router_view, { class: "pb-10 w-full m-auto mt-10" }),
    _createVNode(_component_Footer)
  ]))
}